module.exports = __webpack_public_path__ + "img/twotoplan.7192d5e2.svg";